import { render, staticRenderFns } from "./quill-editor.vue?vue&type=template&id=33d84527&scoped=true&"
import script from "./quill-editor.vue?vue&type=script&lang=js&"
export * from "./quill-editor.vue?vue&type=script&lang=js&"
import style0 from "./quill-editor.vue?vue&type=style&index=0&id=33d84527&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d84527",
  null
  
)

export default component.exports